module.exports = __webpack_public_path__ + "img/4.26b54321.png";